import { useRouteContext } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import type { CrossChainRoute } from '@/lib/query-options';
import MingcuteLink2Line from '~icons/mingcute/link-2-line';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../ui/empty';
import { TransferCardContent } from './transfer-card-content';

const GRADIENT_STYLES = {
  topLeft: {
    background:
      'radial-gradient(ellipse 100% 100% at 50% 50%, #e3f2ff 0%, transparent 100%)',
  },
  bottomRight: {
    background:
      'radial-gradient(ellipse 100% 100% at 50% 50%, #ffe5ef 0%, transparent 100%)',
  },
} as const;

export function TransferCard() {
  const { t } = useTranslation();
  const { crossChainRoutes } = useRouteContext({
    from: '__root__',
  });

  return (
    <div className="w-full max-w-md relative overflow-hidden rounded-xl shadow-xl">
      <Decoration />

      <Card className="bg-background/50 relative backdrop-blur-xl rounded-none border-0">
        <CardHeader>
          <CardTitle className="font-anta italic text-xl">
            {t('common.transferBridge')}
          </CardTitle>
        </CardHeader>
        <CardContent>
          {crossChainRoutes.length ? (
            <TransferCardContent
              crossChainRoutes={
                crossChainRoutes as [CrossChainRoute, ...CrossChainRoute[]]
              }
            />
          ) : (
            <Empty>
              <EmptyHeader>
                <EmptyMedia variant="icon">
                  <MingcuteLink2Line className="w-6 h-6" />
                </EmptyMedia>
                <EmptyTitle>{t('transfer.noRoutes')}</EmptyTitle>
                <EmptyDescription>
                  {t('transfer.noCrossChainRoutesFound')}
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

function Decoration() {
  return (
    <>
      {/* Top-left blue gradient */}
      <div
        className="absolute w-[30rem] h-[30rem] -left-1/3 -top-1/3 z-0 pointer-events-none"
        style={GRADIENT_STYLES.topLeft}
      />
      {/* Bottom-right pink gradient */}
      <div
        className="absolute w-[24rem] h-[24rem] -right-1/3 -bottom-1/3 z-0 pointer-events-none"
        style={GRADIENT_STYLES.bottomRight}
      />
    </>
  );
}
